/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosInstance } from "axios";
import { instanceLoggedAPI, instanceFormAPI } from "../axiosConfig";

export default class RecruiterAPIService {
  private axiosInstance: AxiosInstance;
  private instanceForm: AxiosInstance;

  constructor() {
    this.axiosInstance = instanceLoggedAPI;
    this.instanceForm = instanceFormAPI;
  }

  async getInternals(): Promise<unknown> {
    return this.axiosInstance.get(`/account_members?roles=sourcing_recruiter`);
  }

  async listInternals(): Promise<unknown> {
    return this.axiosInstance.get(`/list_internal_recruiters`);
  }
}
export const RecruiterAPI = new RecruiterAPIService();
